import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import Container from 'ls-common-client/dist/components/Container';
import Animation from 'ls-common-client/dist/components/Animation';
import profileLoader from '../../animations/profileLoader.json';
import { categoryGuideArticlesQuery } from '../../gql/cms';
import AddABusiness from '../../components/AddABusiness';
import ScrollToTop from '../../components/ScrollToTop';
import DigitalMarketingBanner from '../../components/DigitalMarketingBanner';
import ReviewForm from '../../components/ReviewForm';
import LayoutContainer from '../../components/LayoutContainer';
import GuidesTop from '../../components/Landing/GuidesTop';
import slugify from '../../utils/slugify';
import ArticlesList from './ArticlesList';
import useSsr from '../../hooks/useSsr';
import getCategoryArticleFeatureImage from '../../utils/getCategoryArticleFeatureImage';
import CategoryGuideHeaderBackground from '../../assets/guides/categoryGuideBackground.png';
import Meta from './Meta';
import redirects from './redirects';

const StyledContainerRoot = styled(Container)`
  background: #f8f8f8;

  .Landing__Heading__root {
    margin-top: 60px;
    margin-bottom: 40px;
  }

  .AnimatedBanner__root.GuidesTop__AnimatedBanner {
    min-height: 380px;
  }

  .CategoryGuide__Content.LayoutContainer__root {
    max-width: 1262px;
  }

  @media (max-width: 767px) {
    .Landing__Heading__root {
      margin-top: 30px;
    }
  }
`;

const ssr = ({ params, redirect }) => {
  const { categoryName = '' } = params;

  return [
    {
      name: 'CategoryGuideArticles',
      query: categoryGuideArticlesQuery,
      variables: {
        categoryName,
        size: 50,
      },
      callback: (data, errors) => {
        const url = redirects({ data, errors });
        return url ? redirect(url) : false;
      },
    },
  ];
};

const CategoryGuide = () => {
  const { CategoryGuideArticles, redirectUrl } = useSsr(ssr);

  const { localsearchCMSArticles } = CategoryGuideArticles || {};
  const { results = [], categoryFeatureImage = [] } =
    localsearchCMSArticles || {};
  const { article } = (results && results[0]) || {};
  const { primaryCategoryName = '' } = article || {};

  const firstArticleImage = useMemo(() => {
    const [firstObj] = categoryFeatureImage || [];
    const { name: featureImage } = firstObj || {};
    return getCategoryArticleFeatureImage(primaryCategoryName, featureImage);
  }, [primaryCategoryName, categoryFeatureImage]);

  if (redirectUrl)
    return (
      <StyledContainerRoot>
        <Container width="150px" margin="0 auto">
          <Animation data={profileLoader} width="150px" />
        </Container>
        <Redirect to={redirectUrl} />
      </StyledContainerRoot>
    );

  return (
    <StyledContainerRoot className="CategoryGuide__root">
      <ScrollToTop />
      <Meta
        title={`${primaryCategoryName} Guides & Cost Resources`}
        urlSlug={`/guides/${slugify(primaryCategoryName)}`}
        image={firstArticleImage}
        categoryName={primaryCategoryName}
      />
      <GuidesTop
        heading={`${primaryCategoryName} Guides & Resources`}
        headerTransparent
        bannerImage={CategoryGuideHeaderBackground}
        searchShow={false}
        breadcrumbs={[
          {
            breadcrumb: 'Localsearch',
            url: '/',
          },
          {
            url: '/guides',
            breadcrumb: 'Information & Cost Guides in Australia',
          },
          {
            url: `/guides/${slugify(primaryCategoryName)}`,
            breadcrumb: `${primaryCategoryName} Guides & Resources`,
          },
        ]}
      />
      <LayoutContainer className="CategoryGuide__Content">
        <ArticlesList articles={results} categoryName={primaryCategoryName} />
      </LayoutContainer>
      <DigitalMarketingBanner />
      <ReviewForm />
      <AddABusiness />
    </StyledContainerRoot>
  );
};

export { ssr };

export default CategoryGuide;
